var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "subnav-header" },
    [
      _c(
        "v-list",
        _vm._l(_vm.dtWidget, function(menu, i) {
          return _c(
            "v-list-tile",
            {
              key: i,
              class: [
                menu.key === _vm.activeMenu ? "turquoise primaryDark--text" : ""
              ],
              on: {
                click: function($event) {
                  _vm.goTo(menu.key)
                }
              }
            },
            [
              _c(
                "v-list-tile-content",
                [
                  _c("v-list-tile-title", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(_vm.lblSetting.serviceBookSidebar[menu.key])
                      ) +
                        " " +
                        _vm._s(_vm.getTotal(menu.totalKey))
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-83683884", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83683884","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/service-book/components/sidebar/template.html
// module id = null
// module chunks = 